<template>
  <v-list-tile v-if="!isEditing" avatar ripple class="it-hv">
    <v-list-tile-avatar>
      <font-awesome-icon :icon="['fal', 'graduation-cap']"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-sub-title class="caption">
        <span class="font-weight-bold">{{ printRank }}：</span>{{ printDept }}
      </v-list-tile-sub-title>
      <v-list-tile-title>{{ printName }}</v-list-tile-title>
      <v-list-tile-sub-title class="caption"><span class="font-weight-bold">{{ printStatus }}：</span>{{ printDate }}</v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-menu offset-y>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading || isLoading"><v-icon>more_vert</v-icon></v-btn>
        <v-list>
          <v-list-tile @click="edit">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'pencil']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>編集する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="remove">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'trash-alt']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>削除する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-list-tile-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-tile>
  <v-container v-else>
    <v-layout wrap class="pb-4">
      <v-flex xs12 class="px-3">
        <v-combobox
          v-model="form.rank"
          label="学位"
          :rules="rules.rank"
          :items="getRankItems"></v-combobox>
      </v-flex>
      <v-flex xs12 class="px-3">
        <v-text-field
          v-model="form.name"
          label="学校名"
          :rules="rules.name"></v-text-field>
      </v-flex>
      <v-flex xs12 class="px-3">
        <v-text-field
          v-model="form.dept"
          label="学部・学科名"></v-text-field>
      </v-flex>
      <v-flex xs12 class="px-3">
        <v-radio-group required row
          v-model="form.status"
          label="在籍状況"
          :rules="rules.status">
          <v-radio v-for="(item, key) in getStatusItems" :key="key"
            color="blue darken-2"
            :label="item"
            :value="key"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 class="px-3">
        <v-menu lazy offset-y full-width
          v-model="config.datepicker.date"
          transition="scale-transition"
          min-width="290px"
          :close-on-content-click="false">
          <v-text-field readonly required
            v-model="printFormatedDate"
            :rules="rules.date"
            slot="activator"
            label="卒業・中退日"></v-text-field>
          <v-date-picker
            v-model="form.date"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="config.datepicker.date = false"></v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
export default {
  name: 'clientAboutBackgroundsCareer',
  components: {
    UtilConfirmModal
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'career',
        status: {
          loading: false
        },
        datepicker: {
          date: false
        }
      },
      meta: {
        ranks: [
          '中学校',
          '高校',
          '高専',
          '専門学校',
          '短大',
          '大学',
          '大学院',
          '博士'
        ]
      },
      form: {
        id: '',
        name: '',
        rank: '',
        dept: '',
        status: '',
        date: ''
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ],
        rank: [
          v => !!v || '必須項目です'
        ],
        status: [
          v => !!v || '必須項目です'
        ],
        date: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: '' + (dt.id ? dt.id : ''),
          name: dt.name ? dt.name : '',
          rank: dt.rank ? dt.rank : '',
          dept: dt.dept ? dt.dept : '',
          status: dt.status ? dt.status : '',
          date: dt.date ? dt.date : ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          name: this.$props.data.name ? this.$props.data.name : '',
          rank: this.$props.data.rank ? this.$props.data.rank : '',
          dept: this.$props.data.dept ? this.$props.data.dept : '',
          status: this.$props.data.status ? this.$props.data.status : '',
          date: this.$props.data.date ? this.$props.data.date : ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? ('career_' + this.$props.data.id) : '',
          type: this.config.type
        }
      })
    },
    remove: function () {
      this.$refs.confirm.open({
        title: '学歴の削除',
        message: 'この学歴を削除してもよろしいですか？',
        callback: () => {
          this.$set(this.config.status, 'loading', true)
          this.axios.post(this.$url.api + 'user/about/delete/meta', {
            id: this.$props.data.id
          }, {
            headers: {
              'user-token': this.$localStorage.get('jwt')
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'remove',
                data: {
                  type: 'careers',
                  id: res.data.data.id ? res.data.data.id : ''
                }
              })
            }
          })
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === ('career_' + this.$props.data.id))
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === ('career_' + this.$props.data.id)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === ('career_' + this.$props.data.id)
      )
    },
    printRank () {
      return (
        this.$props.data &&
        this.$props.data.rank
      ) ? this.$props.data.rank : ''
    },
    printName () {
      return (
        this.$props.data &&
        this.$props.data.name
      ) ? this.$props.data.name : '学歴'
    },
    printDept () {
      return (
        this.$props.data &&
        this.$props.data.dept
      ) ? this.$props.data.dept : ''
    },
    printStatus () {
      return (
        this.$props.data &&
        this.$props.data.status &&
        this.$meta.career.status[this.$props.data.status]
      ) ? this.$meta.career.status[this.$props.data.status] : ''
    },
    printDate () {
      return (
        this.$props.data &&
        this.$props.data.date
      ) ? this.$moment(this.$props.data.date).format('YYYY/MM/DD') : ''
    },
    printFormatedDate () {
      return (
        this.form &&
        this.form.date
      ) ? this.$moment(this.form.date).format('YYYY/MM/DD') : ''
    },
    getRankItems () {
      return this.meta.ranks
    },
    getStatusItems () {
      return this.$meta.career.status
    }
  }
}
</script>
